export default __webpack_public_path__ + "static/media/phone.c7509490.svg";